<div class="content-pane">
  <h1>Log In</h1>
  <div class="block-copy">
    <p>Log in with organizational credentials for enhanced content and functionality.</p>
    <p>Select your organization:</p>
  </div>
  <div class="login-service">
    @for (s of loginServices; track s) {
      @if (s.image) {
        <button [title]="s.name" matButton="outlined" class="service-logo" (click)="authService.beginLogin(s.id)">
          <img
            [alt]="s.name"
            [title]="s.name"
            [src]="s.image"
            (error)="getBackupImage($event, s.id)"
            (load)="handleSquishyImage($event)"
          />
        </button>
      }
    }
  </div>
  <div class="actions">
    <button matButton="filled" class="secondary-container-button" onclick="window.history.go(-1)">
      <mat-icon class="material-symbols-outlined">cancel_outlined</mat-icon> Continue as Guest
    </button>
  </div>
</div>
